/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router'
import { CustomCard } from 'src/components'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import { IntegrationSettingsFormValues } from 'src/core/models'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import DeleteIntegrationModal from './DeleteIntegrationModal/DeleteIntegrationModal'
import IntegrationSettingsFooter from './IntegrationSettingsFooter/IntegrationSettingsFooter'
import { forms, WhiteLabelFormSection, WhiteLabelFormWelcomeText } from './white-label-form'
import {
  integrationWhiteLabelSelector,
  integrationStaticsSelector,
  currencyListSelector,
  selectCurrencyToken,
} from 'src/features'

const IntegrationSettings: React.FC = () => {
  const route = useRouter()
  const { id } = route.query
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()
  const dispatch = useAppDispatch()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const currency_code = useAppSelector(selectCurrencyToken)
  const statics = useAppSelector(integrationStaticsSelector)
  const { data: { integration_logo }, loading: loadingStatics } = statics
  const { loading, whiteLabel } = useAppSelector(integrationWhiteLabelSelector)
  const currencyList = useAppSelector(currencyListSelector)
  const [formValues, setFormValues] = useState<IntegrationSettingsFormValues>(null)
  const isLoading = loadingStatics || loading

  const behavioralSections = forms.behavioralFields({
    t, formValues, setFormValues, whiteLabel,
    dispatch, integrationId: +id, currencyList, isMobile
  })

  const lookAndFeelSections = forms.lookFeelFields({
    t, formValues, setFormValues, whiteLabel,
    dispatch, integrationId: +id, integration_logo, currency_code
  })

  useEffect(() => {
    setFormValues({ ...whiteLabel, integration_logo: integration_logo })
  }, [whiteLabel])

  return <>

    {/* Behavoiral Sections */}
    {whiteLabel && <CustomCard
      loading={isLoading}
      cardTitle={t('Whitelabel.ConfigureBehaviour')}
    >
      <WhiteLabelFormSection sections={behavioralSections} />
    </CustomCard>}

    {/* Look and Feel Sections */}
    <CustomCard
      loading={isLoading}
      cardTitle={t('Whitelabel.ConfigureLook')}
      className='mt-4'
    >
      <WhiteLabelFormSection sections={lookAndFeelSections} />
    </CustomCard>

    {/* Text sections */}
    {whiteLabel && <CustomCard
      loading={isLoading}
      cardTitle={t('Whitelabel.ConfigureTexts')}
      className='mt-4'
    >
      {formValues && <WhiteLabelFormWelcomeText
        formValues={formValues}
        setFormValues={setFormValues}
      />}
    </CustomCard>}

    <IntegrationSettingsFooter handleDeleteClick={() => setIsModalVisible(true)} />

    <DeleteIntegrationModal
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      id={+id}
    />
  </>
}

export default IntegrationSettings
